export default function TestIframe() {
    return (

        <iframe src="http://localhost:3000/iframe" width="100%" height="100%" style={{ border: 'none', height: '100vh' }}></iframe>

    );
}